import "aos/dist/aos.css";
import React, {useEffect} from "react";
import Section from "../section";
import HelperService from "../../services/helper-service";
import FormatService from "../../services/format-service";

export default function UploadFilesList({
                                           files=[],
                                           filesData=[],
                                           onChange=null,
                                           attachmentTypes=[],
                                           attachmentCategories=[],
                                           cardClass='col-12',
                                           ...rest
}){

  const canChange = (onChange && 'function' === typeof onChange);

  const removeFile = (file, index)=>{
    const newFiles = [...files];
    const newFilesData = [...filesData];
    newFiles.splice(index, 1);
    newFilesData.splice(index, 1);
    if (canChange){
      onChange({files: newFiles, filesData: filesData});
    }
  };

  const setFilesData = (prop, e, file, index)=>{
    const newFilesData = [...filesData];
    newFilesData[index][prop] = e.target.value;
    if (canChange){
      onChange({files: files, filesData: newFilesData});
    }
  };

  return (
    <>
      {files && files.length>0 && <Section animation={HelperService.getRandomAnimation()} className="col-12">
        <div className="row">
          {files && files.map((f, i)=>{
            return (<div className={cardClass} key={i}>
              <div className="card" >
                <div className="card-body text-dark">
                  <div className="row">
                    {f.fileData?.thumb && <div className="col-sm-12 col-md-3">
                      <img src={f.fileData.thumb} className="img-fit" alt='' />
                    </div>}
                    <div className="col">
                      <div className="row">
                        <div className="col-12 d-flex justify-content-between text-break"><span>{f.path}</span> {canChange && <span className="mdi mdi-close text-muted hover-text-danger clickable " onClick={()=>removeFile(f, i)}></span>}</div>
                        <div className="col-12 mt-1 text-muted">{FormatService.formatNumber(f.size/1000)} kb</div>

                        <div className="col-12 mt-1">
                          <input type="text"
                                 className="form-control form-control-sm"
                                 value={filesData[i].title}
                                 placeholder="Názov"
                                 onChange={(e)=>setFilesData('title', e, f, i)} />
                        </div>

                        <div className="col-12 mt-1">
                          <input type="text"
                                 className="form-control form-control-sm"
                                 value={filesData[i].description}
                                 placeholder="Popis"
                                 onChange={(e)=>setFilesData('description', e, f, i)} />
                        </div>

                        {attachmentCategories && attachmentCategories.length>0 && <div className="col-12 mt-1">
                          <select className="form-select form-select-sm"
                                  value={filesData[i].attachment_category_id}
                                  placeholder="Kategória"
                                  onChange={(e)=>setFilesData('attachment_category_id', e, f, i)}>
                            <option value="">nezaradený dokument</option>
                            {attachmentCategories.map(opt=>{
                              return (<option key={opt.id} value={opt.id}>{opt.title}</option>)
                            })}
                          </select>
                        </div>}

                        {attachmentTypes && attachmentTypes.length>1 && <div className="col-12 mt-1">
                          <select className="form-select form-select-sm"
                                  value={filesData[i].attachment_type_id}
                                  placeholder="Typ"
                                  onChange={(e)=>setFilesData('attachment_type_id', e, f, i)}>
                            {attachmentTypes.map(opt=>{
                              return (<option key={opt.val} value={opt.val}>{opt.title}</option>)
                            })}
                          </select>
                        </div>}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>);
            })}
          </div>
      </Section>}
    </>
  );
}
